import React, { memo, useCallback, useState } from "react";
import clsx from "clsx";
import { AppBar, Box, IconButton, Theme, Tooltip } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { Link, useLocation } from "react-router-dom";
import { Help } from "@mui/icons-material";
import OrganizationSelect from "../organizationSelect";
import logo from "../../assets/logo.png";
import FileUpload from "../fileUpload";
import TipsAndTricksDialog from "../dialogs/tipsAndTricksDialog";
import InvitationsPopup from "../popups/invitationsPopup";
import { useAuthorize } from "../../mutationsQueries/user";
import AccountHeaderPopup from "../popups/accountHeaderPopup";
import { HOME_PAGE } from "../../util/constants";

const useStyles = makeStyles((theme: Theme) => ({
  logo: {
    height: 39,
  },
  appBar: {
    padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
  },
  button: {
    color: "white",
  },
  headerButtonWrapper: {
    marginLeft: "auto",
  },
  hideHeader: {
    display: "none",
  },
  spacing: {
    marginLeft: `${theme.spacing(1.5)} !important`,
  },
}));

const Header = () => {
  const [openTipsDialog, setOpenTipsDialog] = useState<boolean>(false);
  const { data: userData }: { data: { user_id: number } | undefined } =
    useAuthorize();
  const location = useLocation();
  const classes = useStyles();

  const onOpenTipsDialog = useCallback(() => setOpenTipsDialog(true), []);
  const onCloseTipsDialog = useCallback(() => setOpenTipsDialog(false), []);

  return (
    <AppBar
      position="fixed"
      className={clsx(classes.appBar, {
        [classes.hideHeader]: location.pathname.includes("/vouchers/edit"),
      })}
    >
      <Box display={"flex"} alignItems={"center"}>
        <Link to={HOME_PAGE}>
          <img src={logo} className={classes.logo} alt={"Logo"} />
        </Link>
        <Box className={classes.headerButtonWrapper}>
          <OrganizationSelect />
          <FileUpload />
          {false && (
            <Tooltip title={"Tips and Tricks"}>
              <IconButton
                className={classes.spacing}
                onClick={onOpenTipsDialog}
              >
                <Help color={"secondary"} />
              </IconButton>
            </Tooltip>
          )}
          <InvitationsPopup
            buttonClassname={classes.spacing}
            id={userData?.user_id}
          />
          <AccountHeaderPopup />
        </Box>
      </Box>
      <TipsAndTricksDialog open={openTipsDialog} onClose={onCloseTipsDialog} />
    </AppBar>
  );
};

export default memo(Header);
